const single_sign_on = {
    forbidden_domains: '공개 이메일 도메인은 허용되지 않습니다.',
    duplicated_domains: '중복된 도메인이 있습니다.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
